import type { QueryKey } from '@tanstack/react-query';
import type { GetReceiptBatchListParams } from './api';

export const RECEIPT_BATCH_LIST_PHOENIX_KEY = (
  params?: GetReceiptBatchListParams
): QueryKey => {
  if (params) {
    return ['receipt-batch-list-phoenix-sp', params];
  }
  return ['receipt-batch-list-phoenix-sp'];
};

export const RECEIPT_BATCH_PHOENIX_KEY = (id: string | undefined): QueryKey => {
  return ['receipt-batch-phoenix-sp', id ?? '--'];
};
